<template>
  <div class="mask" v-show="isShow">
    <div class="loginbg">
      <div class="close" @click="close"></div>
      <div class="loginWrapper">  <!--登录弹窗-->
        <h2>用户登录</h2>
        <div class="loginId">
          <Inputc class="textCenter" tipMsg="身份证/手机号" v-model="key" ref="a"/>
        </div>
        <div class="passWord">
          <Inputc class="textCenter" tipMsg="密码" type="password" v-model="idPasswordKey" ref="b"/>
        </div>
        <input type="button" class="loginBtn themeBg" value="登录" @click="login"/>
        <div class="sign">
          <router-link class="signup" @click.native="hideLogin"  to="/signup">立即注册</router-link>
          <router-link class="forget" @click.native="hideLogin"  to="/forget">忘记密码</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {StorageUtil, LocalStorageUtil} from '../common/Auth.js';
  import {MD5Util} from '../common/MD5Util.js';
  import Inputc from '../components/input.vue';
  import {ajaxUtil} from '../common/AjaxUtil.js';
  import {api, msg} from '../common/config.js';
  import {store} from '../store/store.js'
  import $ from "jquery";
  import {CommonUtil} from '../common/CommonUtil.js';

  export default {
    name: 'loginmask',
    data() {
      return {
        key: '',
        idPasswordKey: '',
        phone: '',
        idCard: '',
        idPassword: '',
        readerId: '',
        isShow: false,
        isClickBtn: false,

      }
    },
    components: {
      Inputc
    },
    beforeMount() {
      //判断是否需要免密登录（若需要免密登录，则该函数内部会直接免密登录）
      this.authorityLogin();
    },
    methods: {
      showLogin() {
        this.isShow = true;
        CommonUtil.saveRepeatLoginUrl();
      },
      close(){
        this.isShow = false;
      },
      hideLogin() {
        store.wrap.user = null;
        StorageUtil.removeObject('user');
        this.isShow = false;
        location.reload();
      },
      /**
       * 免密登录（通过检查url里的参数，并进行授权校验，通过则直接登录;失败则不做任何处理，扔保持未登录状态）
       */
      authorityLogin:function () {
        let host=document.domain;
        let hallCode = host.indexOf('.')>0 ? host.substring(0,host.indexOf('.')) : '';
        let params=this.$route.query;
        if(!params||!params.account||!params.token){
          params=CommonUtil.getURLParams();
        }
        if(params&&params.account&&params.token&&params.timestamp&&params.timestamp.length==13&&/^[0-9]+$/.test(params.timestamp)){
          let newParams=CommonUtil.copyObject(params);
          delete newParams['account'];
          delete newParams['token'];
          delete newParams['timestamp'];
          this.$router.push({query: newParams});
          let time=new Date().getTime()-params.timestamp;
          if((hallCode.length==4||hallCode.length==5)&&/^[a-zA-Z]+$/.test(hallCode)
              &&window.location.href.indexOf('/indexpage')>-1&&time>=0 && time<=30*1000){
            let authorityLoginData ={
              hallCode:hallCode,
              readerAccount:params.account,
              authorityPermissionToken:params.token,
              timestamp:params.timestamp
            }
            this.login(authorityLoginData);
          }
        }
      },
      /**
       * 读者登录
       * @param authorityLoginData 授权登录参数数据，非必备（当为null时为普通页面登录，当非null时为授权免密登录）
       */
      login: function (authorityLoginData) {
        var _this = this;
        let loginData = null;
        let loginUrl = api.reader.login;
        let isAuthorityLogin=authorityLoginData&&authorityLoginData.readerAccount;
        if(isAuthorityLogin){
          loginUrl = api.reader.authorityLogin;
          loginData = authorityLoginData;
        }else {
          if (this.isClickBtn) {
            return;
          }
          this.isClickBtn = true;
          var locationHref=window.location.href;
          if (_this.key.trim() == null || _this.key.trim().length == 0) {
            _this.$refs.a.showError(msg.emptyInputAccount);
            _this.isClickBtn = false;
            return;
          } else if (_this.idPasswordKey.trim() == null || _this.idPasswordKey.trim().length == 0) {
            _this.$refs.b.showError(msg.emptyInputPass);
            _this.isClickBtn = false;
            return;
          }

          if(_this.key.length==11){
            _this.phone = _this.key;
            _this.idCard ="";
          }else {
            _this.idCard = _this.key;
            _this.phone ="";
          }
          _this.idPassword = MD5Util.hex_md5(_this.idPasswordKey);
          loginData = {
            idCard: _this.idCard,
            idPassword: _this.idPassword,
            phone: _this.phone
          };
        }
        ajaxUtil.ajaxLogin(loginUrl, loginData, 'POST', (data) => { //成功
          _this.readerId = data.readerId;
          StorageUtil.storeString("token", data.token);
          StorageUtil.storeObject("user", data);
          CommonUtil.setCookie("loginStart", "true", 0.375);//0.375
          CommonUtil.setCookie("noMovingTime", "true", 0.125);//0.125
          store.token = data.token;
          store.user = data;
          if(store.wrap) {
            store.wrap.user = data;
          }
          _this.$emit('success', data);
          let refreshPage=false;
          if(locationHref.indexOf("/readercomments") > -1){
            location.reload();
            refreshPage=true;
          }
          //如果设置了historyPath，则跳到historyPath
          var historyPath = StorageUtil.getString("historyPath");
          if(historyPath != null){
            this.$router.push(historyPath);
            StorageUtil.removeObject("historyPath");
            refreshPage=true;
          }
            this.getNoNum(data);
          if(!refreshPage){
            _this.isClickBtn = false;
            _this.isShow = false;
          }else{
            return;
          }
            _this.key = '';
            _this.idPasswordKey = '';
            loginData.phone = '';
            loginData.idCard = '';
            loginData.idPassword = '';
        }, (result) => { //失败
          if(!isAuthorityLogin){
            this.$emit('fail', result)
            if (result.errorCode == 30102) {
              _this.key = '';
              _this.idPasswordKey = '';
              loginData.phone = '';
              loginData.idCard = '';
              loginData.idPassword = '';
              _this.$refs.a.showError(msg.accountExist);
            } else if (result.errorCode == 30103) {
              _this.idPasswordKey = '';
              loginData.idPassword = '';
              _this.$refs.b.showError(msg.passError);
            }
            _this.isClickBtn = false;
          }
        }, this);
      },
        //请求未读消息
      getNoNum: function (user) {
          var url = api.personalnews.overdue.replace('{idCard}', user.idCard);
          ajaxUtil.ajaxJson(url, null, 'GET', (data) => {
              store.wrap.messageCount=data.messageCount;
          }, null, this)
          var otherNewsUrl = api.personal.getUnreadcount;
          ajaxUtil.ajaxJson(otherNewsUrl,{readerId: user.readerId},'POST',(data) => {
              store.wrap.unreadCount=data.unreadCount;
          }, null, this)
      }
    }
  }
</script>

<style lang="sass" scoped>
  .loginbg
    position: absolute
    top: 50%
    left: 50%
    margin: -206px 0 0 -200px
    width: 400px
    height: 412px
    background: #fff
    .close
      @extend .close
      background-image: url("../assets/images/Close.png")
    .loginWrapper
      margin: 0 auto
      width: 296px
      text-align: center

    .loginWrapper h2
      margin-top: 44px
      margin-bottom: 54px
      font-size: 24px
      line-height: 30px
      font-weight: 500
      color: #333

    .loginId, .passWord
      margin-bottom: 26px
      width: 296px
      height: 45px

    .loginBtn
      margin-bottom: 38px
      width: 296px
      height: 45px
      border: none
      border-radius: 4px
      font-size: 16px
      color: #ffffff
      cursor: pointer

    .sign
      height: 14px
      line-height: 14px

    .forget
      padding-left: 23px
      height: 14px
      font-size: 14px
      color: #333
      &:hover
        color: $themecolor1
        text-decoration: none

    .signup
      @extend .forget
      padding:
        left: 0
        right: 23px
      border-right: 1px solid #dedede
  .web2
    .forget, .signup
      &:hover
        color: $themecolor2!important
</style>
